import { httpClient } from "@services/api/httpClient";

export interface IGetFormBuilderAccessTokenInput {
    forms: ("register" | "menu" | "calendarMenu" | "checkout")[]
}

export const generateUUID = async (): Promise<string> => {
    const response = await httpClient.post("/auth/generate-uuid");
    return response.data?.uuid;
}